import React, { useState, useEffect } from 'react';
import './Reviews.css';
import Rating from './Rating';
// TODO: Import your customer reviews array here
// import { customerReviews } from './path/to/your/reviews/data';

// Expected format for your reviews array:
// const customerReviews = [
//   {
//     id: 1,
//     name: "Customer Name",
//     rating: 5, // 1-5 stars
//     date: "2024-03-15", // YYYY-MM-DD format
//     review: "Review text here...",
//     product: "Product Name"
//   },
//   // ... more reviews
// ];

export default function Reviews() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    // Get reviews from products stored in localStorage
    const products = JSON.parse(localStorage.getItem('Products')) || [];
    const allReviews = [];

    products.forEach(product => {
      if (product.reviews && Array.isArray(product.reviews)) {
        allReviews.push(...product.reviews);
      }
    });

    // Sort reviews by date (newest first)
    allReviews.sort((a, b) => new Date(b.date) - new Date(a.date));

    setReviews(allReviews);
  }, []);

  // Temporary sample data - replace with your actual reviews array
  const sampleReviews = [
    {
      id: 1,
      name: "Ahmed Khan",
      rating: 5,
      date: "2024-03-15",
      review: "Absolutely love this shirt! The quality is outstanding and the fit is perfect. The Egyptian hieroglyphs design is unique and eye-catching. Highly recommend!",
      product: "Glory Decay"
    },
    {
      id: 2,
      name: "Sara Ahmed",
      rating: 4,
      date: "2024-03-12",
      review: "Great quality fabric and comfortable to wear. The design is beautiful. Only wish it came in more colors. Overall very satisfied with the purchase.",
      product: "Glory Decay"
    },
    {
      id: 3,
      name: "Muhammad Ali",
      rating: 5,
      date: "2024-03-10",
      review: "Inifits has become my go-to brand for streetwear. This piece is exactly what I was looking for. Fast shipping and excellent customer service.",
      product: "Alter:ONE"
    },
    {
      id: 4,
      name: "Fatima Noor",
      rating: 4,
      date: "2024-03-08",
      review: "Love the minimalist design and the comfort level. Perfect for everyday wear. The price is reasonable for the quality you get.",
      product: "Glory Decay"
    },
    {
      id: 5,
      name: "Hassan Raza",
      rating: 5,
      date: "2024-03-05",
      review: "Amazing brand! The attention to detail in their designs is impressive. This shirt has quickly become a favorite in my wardrobe.",
      product: "Alter:ONE"
    },
    {
      id: 6,
      name: "Ayesha Malik",
      rating: 4,
      date: "2024-03-03",
      review: "Good quality and unique design. The sizing runs a bit large, but overall very happy with my purchase. Will definitely buy again.",
      product: "Glory Decay"
    },
    {
      id: 7,
      name: "Omar Farooq",
      rating: 5,
      date: "2024-02-28",
      review: "Inifits delivers on their promise of quality and affordability. The Egyptian hieroglyphs are printed perfectly and the fabric is premium.",
      product: "Glory Decay"
    },
    {
      id: 8,
      name: "Zainab Khan",
      rating: 4,
      date: "2024-02-25",
      review: "Beautiful design and great fit. The colors are vibrant and the material is comfortable. Minor issue with packaging but product is excellent.",
      product: "Alter:ONE"
    },
    {
      id: 9,
      name: "Bilal Ahmed",
      rating: 5,
      date: "2024-02-22",
      review: "Outstanding quality and design. Inifits has set a new standard for Pakistani streetwear. Can't wait to see more from this brand!",
      product: "Glory Decay"
    },
    {
      id: 10,
      name: "Maryam Shah",
      rating: 4,
      date: "2024-02-20",
      review: "Love the concept and execution. The shirt is comfortable and the design is unique. Great value for money. Highly recommended.",
      product: "Alter:ONE"
    }
  ];

  // Use actual reviews if available, otherwise use sample data
  const displayReviews = reviews.length > 0 ? reviews : sampleReviews;

  const [currentPage, setCurrentPage] = useState(1);
  const reviewsPerPage = 3;
  const totalPages = Math.ceil(displayReviews.length / reviewsPerPage);

  // Get current reviews
  const indexOfLastReview = currentPage * reviewsPerPage;
  const indexOfFirstReview = indexOfLastReview - reviewsPerPage;
  const currentReviews = displayReviews.slice(indexOfFirstReview, indexOfLastReview);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Generate page numbers to display
  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 3;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 2) {
        pages.push(1, 2, 3);
      } else if (currentPage >= totalPages - 1) {
        pages.push(totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(currentPage - 1, currentPage, currentPage + 1);
      }
    }

    return pages;
  };

  return (
    <div className="reviews-container">
      <h1 className="reviews-title">Customer Reviews</h1>

      <div className="reviews-list">
        {currentReviews.map((review) => (
          <div key={review.id} className="review-card">
            <div className="review-header">
              <div className="review-user">
                <h3>{review.name}</h3>
                <span className="review-product">{review.product}</span>
              </div>
              <div className="review-rating-date">
                <Rating value={review.rating} />
                <span className="review-date">{review.date}</span>
              </div>
            </div>
            <div className="review-content">
              <p>{review.review}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination Controls */}
      <div className="pagination-controls">
        <button
          className="pagination-btn"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        <div className="page-numbers">
          {getPageNumbers().map((page) => (
            <button
              key={page}
              className={`page-number ${currentPage === page ? 'active' : ''}`}
              onClick={() => handlePageChange(page)}
            >
              {page}
            </button>
          ))}
          {totalPages > 3 && currentPage < totalPages - 1 && (
            <span className="pagination-ellipsis">...</span>
          )}
        </div>

        <button
          className="pagination-btn"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
}